import { render } from "./PageTabContent.vue?vue&type=template&id=2d04fc41"
import script from "./PageTabContent.vue?vue&type=script&lang=js"
export * from "./PageTabContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__